import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Http, Response, ResponseContentType, URLSearchParams } from '@angular/http';
import { RequestOptions } from '@angular/http';
import { environment } from '../../../environments/environment';
import { HttpConst } from '../constants/httpConst';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/timeout';
import { Session } from '../../shared/models/session';
import { MessageService } from './message.service';
import { AuthService } from './auth.service';
import { map } from 'rxjs/operators';

@Injectable()
export class RequestService {
    private api:any = environment.api;
    private apiLocation: any = environment.apiLocation;
    private apiTelemetry: any = environment.apiTelemetry;

    constructor(
        private http : Http,
        private message : MessageService,
        private auth : AuthService,
    ){}

    getBody(url,params,sysmodule,timeout, body?):Promise<any>{
        return new Promise((resolve,reject)=>{
          this.getQueryOptions(sysmodule, params)
          .then(options => {
              if(body) {
                options.body = body;
              }
              this.http.get(this.api+url, options)
              .timeout(timeout)
              .map((res:Response)=>{return res})
              .subscribe((data)  => {
              //   this.updateSession(data);
                resolve(data.json());
              },(error:Response) => {
                this.validateRequest(error);
                reject(error);
              });
          })
        });
    }

    get(url,params,sysmodule,timeout):Promise<any>{
      return new Promise((resolve,reject)=>{
        this.getQueryOptions(sysmodule, params)
        .then(options => {
            this.http.get(this.api+url, options)
            .timeout(timeout)
            .map((res:Response)=>{return res})
            .subscribe((data)  => {
            //   this.updateSession(data);
              resolve(data.json());
            },(error:Response) => {
              this.validateRequest(error);
              reject(error);
            });
        })
      });
    }

    getTelemetry(url,params,sysmodule,timeout):Promise<any>{
    return new Promise((resolve,reject)=>{
        this.getQueryOptions(sysmodule, params)
        .then(options => {
            this.http.get(this.apiTelemetry+url, options)
            .timeout(timeout)
            .map((res:Response)=>{return res})
            .subscribe((data)  => {
            //   this.updateSession(data);
            resolve(data.json());
            },(error:Response) => {
            this.validateRequest(error);
            reject(error);
            });
        })
    });
    }

    post(url,params,sysmodule,timeout):Promise<any>{
        return new Promise((resolve,reject)=>{
            this.getOptions(sysmodule)
            .then(options => {
                this.http.post(this.api+url,params,options)
                .timeout(timeout)
                .map((res:Response)=>{return res})
                .subscribe((data)  => {
                    // this.updateSession(data);
                    resolve(data.json());
                },(error:Response) => {
                    this.validateRequest(error);
                    reject(error);
                });
            })
        });
    }

    postNotValidate(url,params,sysmodule,timeout):Promise<any>{
        return new Promise((resolve,reject)=>{
            this.getOptions(sysmodule)
            .then(options => {
                this.http.post(this.api+url,params,options)
                .timeout(timeout)
                .map((res:Response)=>{return res})
                .subscribe((data)  => {
                    resolve(data.json());
                },(error:Response) => {
                    reject(error.json());
                });
            })
        });
    }

    postNotValidateLocation(url, params, timeout): Promise<any>{
        return new Promise(async (resolve, reject) => {
            let customerId = Number(await localStorage.getItem("customerId"));
            this.getOptionsLocation()
            .then(options => {
                this.http.post(this.apiLocation + url, {
                    "customerId": customerId,
                    "data": params
                }, options)
                .timeout(timeout)
                .map((res:Response) => {return res})
                .subscribe((data) => {
                    resolve(data.json());
                }, (error: Response) => {
                    reject(error);
                })
            })
        });
    }

    put(url,params,sysmodule,timeout):Promise<any>{
        return new Promise((resolve,reject)=>{
            this.getOptions(sysmodule)
            .then(options => {
                this.http.put(this.api+url,params,options)
                .timeout(timeout)
                .map((res:Response)=>{return res})
                .subscribe((data)  => {
                    // this.updateSession(data);
                    resolve(data.json());
                },(error:Response) => {
                    this.validateRequest(error);
                    reject(error);
                });
            })
        });
    }

    delete(url, params, sysmodule, timeout): Promise<any> {
        return new Promise((resolve, reject) => {
            this.getQueryOptions(sysmodule, params)
            .then(options => {
                this.http.delete(this.api + url, options)
                .timeout(timeout)
                .map((res: Response) => { return res })
                .subscribe((data) => {
                    // this.updateSession(data);
                    resolve(data.json());
                }, (error: Response) => {
                    this.validateRequest(error);
                    reject(error);
                });
            })
        });
    }

    postFile(url: string, downloadName: string, params: any, sysmodule: string, timeout: number):Promise<any>{
        return new Promise((resolve,reject)=>{
            this.getOptions(sysmodule).then(options => {
                options.responseType = ResponseContentType.ArrayBuffer;
                this.http.post(this.api+url,params,options)
                .timeout(timeout)                
                .subscribe(response => {
                    resolve(this.handleDownloadSuccess(response, downloadName));
                },(error:Response) => {
                    this.validateRequest(error);
                    reject(error);
                });
            })
        });
    }

    handleDownloadSuccess(response: Response, downloadName: string) {
        const blob = new Blob([response.arrayBuffer()], { type: response.headers.get('content-type') });
        const downloadLink = document.createElement('a');
        downloadLink.href = window.URL.createObjectURL(blob);        
        downloadLink.setAttribute('download', downloadName);
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
    }

    getOptions(sysModule):Promise<RequestOptions>{
        return new Promise((resolve, reject) => {
            let systemConfig:any = environment;
            let constHeaders:any = HttpConst.headers;
            let headers = constHeaders;

            this.auth.getToken().then((token) => {
                headers.token = token;
                headers.app = systemConfig.app;
                headers.module = sysModule;
                headers.uid = this.auth.getUserId();

                resolve(new RequestOptions({ headers: headers}));
            })
        })
    }

    getOptionsLocation(): Promise<RequestOptions>{
        return new Promise((resolve, reject) => {
            let constHeaders:any  = HttpConst.headers;
            let headers = constHeaders;

            this.auth.getToken().then((token) => {
                headers.authorization = `Bearer ${token}`;
                /*headers.token = '';
                headers.app = '';
                headers.module = '';
                headers.uid = '';*/
                resolve(new RequestOptions({headers: headers}));
            });

            
        })
    }

    getQueryOptions(sysModule,params):Promise<RequestOptions>{
        return new Promise((resolve, reject) => {
            let systemConfig:any = environment;
            let urlSearch = new URLSearchParams();
            let constHeaders:any = HttpConst.headers;
            let headers = constHeaders;

            for(let key in params) {
              urlSearch.append(key, params[key]);
            }

            this.auth.getToken().then((token) => {
                headers.token = token;
                headers.app = systemConfig.app;
                headers.module = sysModule;
                headers.uid = this.auth.getUserId();

                resolve(new RequestOptions({ headers: headers, params: urlSearch }));
            })
        })
    }

    /*updateSession(res){
        let { session } = this.ngRedux.getState();
        let newSession = new Session(
            session.user,
            res.status,
            res.headers.get('token')
        );
        Object.assign(session, newSession);
        this.ngRedux.dispatch({ type: Actions.NEW_SESSION, payload: { session: session} });
    }*/

    validateRequest(error){
        switch(error.status){
            case 0:
                // this.message.error('¡Oh, no!','No se pudo establecer comunicación con el servidor, revise su conexión a internet');
                this.message.errorToast('¡Oh, no!', 'No se pudo establecer comunicación con el servidor, revise su conexión a internet');
                break;

            case 400:
            case 500:
                switch(error.json().status){
                    case 4004:
                        this.message.custom({
                            title: 'Renovar sesión',
                            text:error.json().message,
                            imageUrl: 'assets/img/padlock.png',
                            imageWidth: 100,
                            input: 'password',
                            inputPlaceholder: 'Introduzca su contraseña',
                            confirmButtonText: 'Renovar',
                            confirmButtonColor: '#04B404',
                            showCancelButton: false,
                            cancelButtonText: '¡Lo haré despues!',
                            reverseButtons:true,
                            cancelButtonColor:'#d33',
                            showLoaderOnConfirm: true,
                            inputAttributes: {
                                maxlength: '30',
                                autocapitalize: 'off',
                                autocorrect: 'off'
                            },
                            preConfirm: (password) => {
                                return new Promise((resolve) => {
                                    if (password === '') {
                                        // this.message.validate("¡Ups!, aun no has introducido tu contraseña");
                                    }
                                    resolve('');
                                })
                            }
                        }).then((result)=>{
                            if(result.value){
                                this.getOptions('login').then(options => {
                                    this.http.post(this.api+'/login/renew/',{ password : result.value }, options)
                                    .timeout(30000)
                                    .map((res:Response)=>{return res})
                                    .subscribe((data)  => {
                                        // this.updateSession(data);
                                        this.message.success("¡Excelente!","Tu sesión se ha renovado exitosamente");
                                        //this.route.navigateByUrl(this.stage.getOpened());
                                    },(err:Response) => {

                                        this.message.errorToast('¡Ups!', err.json().message).then( () => {
                                            this.validateRequest(error);
                                        });

                                        // this.message.error('¡Ups!',err.json().message).then(()=>{
                                        //     this.validateRequest(error);
                                        // })
                                    });
                                })
                            }
                        });
                    break;

                    case 4002:
                        this.message.warning('¡Ups!',error.json().message+', por favor autentíquese nuevamente').then(()=>{
                            this.auth.logOut();
                        });
                    break;

                    default:
                        // this.message.error('¡Ups!',error.json().message);
                        this.message.errorToast('¡Ups!', error.json().message);
                    break;
                }
                break;

            case undefined:
                if(error.name){
                    switch(error.name){
                        case 'TimeoutError':
                            // this.message.error('¡Ups!','El servidor ha excedido el tiempo de respuesta');
                            this.message.errorToast('¡Ups!', 'El servidor ha excedido el tiempo de respuesta');
                        break;

                        default:
                            // this.message.error('¡Oh, no!','Ha ocurrido algo inesperado, código : (RequestService-validateRequest-ErrorName) : ' + error.name);
                            this.message.errorToast('¡Oh, no!', 'Ha ocurrido algo inesperado, código : (RequestService-validateRequest-ErrorName) : ' + error.name);
                        break;
                    }
                } else {
                    // this.message.error('¡Oh, no!','Ha ocurrido algo inesperado, código : (RequestService-validateRequest) : ' + JSON.stringify(error));
                    this.message.errorToast('¡Oh, no!','Ha ocurrido algo inesperado, código : (RequestService-validateRequest) : ' + JSON.stringify(error));
                    // cuando algo llegue aquí seria buena idea guardar para ir monitoreando posibles errores
                    // inesperados y agregarlos a las validaciones de error
                }
                break;

            default:
                switch (error.name) {
                    case 'TimeoutError':
                        // this.message.error('¡Ups!', 'Se ha excedido el tiempo de respuesta del servidor');
                        this.message.errorToast('¡Ups!', 'Se ha excedido el tiempo de respuesta del servidor');
                        break;

                    default:
                        // this.message.error('¡Oh, no!', 'Ha ocurrido algo inesperado, código de error : ' + JSON.stringify(error.name));
                        this.message.errorToast('¡Oh, no!', 'Ha ocurrido algo inesperado, código de error : ' + JSON.stringify(error.name));
                        break;
                }
                break;
        }
    }
}
